import { FC } from 'react';
import { Box, Typography, CircularProgress } from '@material-ui/core';
import { useAutofixStyles } from './styles';

interface LoadingStateProps {
  text: string;
  testId?: string;
}

export const LoadingState: FC<LoadingStateProps> = ({ text, testId }) => {
  const classes = useAutofixStyles();

  // Convert any non-string values to string for display
  const displayText = String(text);

  return (
    <Box className={`${classes.loadingContainer}`} data-testid={testId}>
      <CircularProgress
        size={16}
        color="primary"
        className={classes.loadingSpinner}
      />
      <Typography variant="body2" className={classes.loadingText}>
        {displayText}
      </Typography>
    </Box>
  );
};
